export const locale = {
    lang: 'es',
    data: {
        USUARIOS: {
            EDIT: {
                TITLE: 'MODIFICAR USUARIO'
            }
        }
    }
};
